import { useEffect, useState } from "react";
import Alert from "../Alert";
import DynamicEditForm from "../DynamicEditForm";
import LoadingSpinner from "../LoadingSpinner";
import ModalLoading from "../Modal/ModalLoading";
import ModalError from '../Modal/ModalError.jsx';
import { useAddPlotOccupantMutation, useGetPlotQuery, useUpdatePlotOccupantMutation } from "/src/redux/plotsApi";
import useQueryEffect from '/src/hooks/useQueryEffect';
import MapEditorPlotOccupantDelete from "./MapEditorPlotOccupantDelete";

const formConfig = {
    autoFocus: true,
    requiredNotBlank: true,
    fields: [
        {
            key: 'lastName',
            title: 'Last Name',
            type: 'text',
            placeholder: 'Doe',
            required: false,
            max: 128,
        },
        {
            key: 'firstName',
            title: 'First Name',
            type: 'text',
            placeholder: 'John',
            required: false,
            max: 128,
        },
        {
            key: 'birthDate',
            title: 'Date of Birth',
            type: 'partialDate',
            // placeholder: 'MM/DD/YYYY',
            // max:'9999-12-31',
            required: false,
        },
        {
            key: 'deathDate',
            title: 'Date of Death',
            type: 'partialDate',
            // placeholder: 'MM/DD/YYYY',
            // max:'9999-12-31',
            required: false,
        },
        {
            key: 'notes',
            title: 'Notes',
            type: 'textarea',
            placeholder: '...',
            required: false,
            max: 1024,
        },
    ]
}

export default function MapEditorPlotOccupantEditor({_id: personId, plotId, onSave, onDiscard}){
    const { data: queryData, error: queryError, isLoading } = useGetPlotQuery(plotId, {skip: !plotId});
    const [updatePerson, { error: mutationError, isLoading: isUpdating, isSuccess: isUpdateSuccess }] = useUpdatePlotOccupantMutation();
    const [addPerson, { error: createError, isLoading: isCreating, isSuccess: isCreateSuccess }] = useAddPlotOccupantMutation();
    const [details, setDetails] = useState(null);
    const [error, setError] = useState(null);

    const userTookAction = useQueryEffect((error)=>{
        if(error){
            setError(error);
        }else{
            console.debug(`successfully ${isUpdateSuccess?'updated':'saved'} ${personId || plotId || 'new'}`);
            onSave();
        }
    }, [isUpdateSuccess, isCreateSuccess], [mutationError, createError]);

    // copy query data to state for editing
    useEffect(()=>{
        if(queryData && plotId && queryData._id == plotId){
            // find person in array
            const people = Array.isArray(queryData.plotOccupants)? queryData.plotOccupants : [];
            const found = people.find(p=>{
                return p._id == personId;
            });
            // found existing person or create new person
            setDetails(found || {});
        }
    },[queryData, personId]);

    // handle user click save button
    function onSaveForm(data){
        userTookAction();
        if(personId){
            updatePerson({
                ...data,
                _id: personId, 
            });
        }else{
            addPerson({
                ...data,
                _id: plotId,
            });
        }
    }

    // handle user click discard button
    function onDiscardForm(){
        console.debug('onDiscard');
        if(queryData && plotId && queryData._id == plotId){
            setDetails(queryData);
        }else if(!plotId){
            setDetails({});
        }
        if(onDiscard) onDiscard();
    }

    return (
        <div>
            {(isUpdating || isCreating) && <ModalLoading title="Saving" absolute="true" />}
            {error && <ModalError title="Error" message={error.message} description={error.status || error.code} callback={()=>setError(null)} />}
            <div className="mb-4">
                {(queryError && (
                    <Alert className='border-t-red-600'><p>{queryError.message || 'Failed to load'}</p></Alert>
                )) || (isLoading && (
                    <LoadingSpinner className='w-6' />
                )) || (details && (
                    <DynamicEditForm formConfig={formConfig} selectedAsset={details} onSave={onSaveForm} onDiscard={onDiscardForm} />
                )) || (
                    <p>Can't Edit, No Entry</p>
                )}
            </div>
            <MapEditorPlotOccupantDelete _id={personId} onDelete={()=>onDiscard && onDiscard()} onError={e=>setError(e)} />
        </div>
    )
}